import { useLocation } from "react-router-dom";
import manifest from "./route-manifest.json";
import { groupFor, languageTarget, normalizePath, retiredTarget } from "./route-policy.js";
export { manifest, retiredTarget };
export const LANGUAGE_CODES = ["he", "en", "ru", "hi", "si", "ta", "th"] as const;
export type Lang = (typeof LANGUAGE_CODES)[number];
export const FOREIGN_LANGS = ["ru", "hi", "si", "ta", "th"] as const;
export type ForeignLang = (typeof FOREIGN_LANGS)[number];
export const LANGUAGE_LABELS: Record<Lang, string> = { he: "🇮🇱 עברית", en: "🇺🇸 English", ru: "🇷🇺 Русский", hi: "🇮🇳 हिन्दी", si: "🇱🇰 සිංහල", ta: "🇸🇬 தமிழ்", th: "🇹🇭 ไทย" };
export function langFromPath(pathname: string): Lang {
  const prefix = normalizePath(pathname).split("/")[1];
  return (LANGUAGE_CODES as readonly string[]).includes(prefix) ? prefix as Lang : "he";
}
export function hePath(pathname: string): string {
  return groupFor(pathname, manifest)?.he || normalizePath(pathname).replace(/^\/(en|ru|hi|si|ta|th)(?=\/|$)/, "") || "/";
}
export function localizePath(pathname: string, lang: Lang): string { return languageTarget(pathname, lang, manifest); }
export const enPath = (pathname: string) => localizePath(pathname, "en");
export function useLang(): Lang { return langFromPath(useLocation().pathname); }
export function useLocalizedPath() { const lang = useLang(); return (path: string) => localizePath(path, lang); }
